// Function to check if the user is a paying subscriber
// We pass in the user info object and check if the subscriptions
// array is populated, but this integration currently
// only supports theStreet / theStreetPro
// subscriptions

export function isPayingSubscriber(userInfo) {
    return userInfo?.subscriptions?.length > 0;
}

export function getPlanCodes(userInfo) {
    return userInfo?.subscriptions?.map((sub) => sub.product);
}

export function isNewsletterSubscriber(userPreferences) {
    return userPreferences?.newsletters?.length > 0;
}

export function getNewsletterSubscriptions(userPreferences) {
    return userPreferences?.newsletters?.map((newsletter) => newsletter.title.toLowerCase());
}
